import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "../openapi";
import { MealTypeResponse } from "../openapi/client";
import { RootState } from "../store";
import { setMealTypes as setMealTypesStore } from "../store/mealTypesSlice";

export default function useMealTypes() {
  const dispatch = useDispatch();
  const [mealTypes, setMealTypes] = useState<MealTypeResponse[]>([]);
  const mealTypesStore = useSelector((state: RootState) => state.mealTypes);

  useEffect(() => {
    const getMealTypes = async () => {
      try {
        const res = await Api.Meal.getTypes();
        setMealTypes(res.data);
        dispatch(setMealTypesStore(res.data));
      } catch (error) {}
    };
    if (mealTypesStore.length) {
      setMealTypes(mealTypesStore);
    } else {
      getMealTypes();
    }
  }, []);
  return mealTypes;
}
